module.exports = __webpack_public_path__ + "static/media/E-Den_1.22575183.jpg";